import type { GetProp } from "antd/es/_util/type";
import Avatar from "antd/es/avatar";
import Badge from "antd/es/badge";
import Checkbox from "antd/es/checkbox";
import type { CheckboxOptionType } from "antd/es/checkbox/Group";
import type { CheckboxGroupProps } from "antd/es/checkbox/Group";
import Col from "antd/es/col";
import Collapse from "antd/es/collapse";
import type { CollapseProps } from "antd/es/collapse";
import ConfigProvider from "antd/es/config-provider";
import DatePicker from "antd/es/date-picker";
import type { DatePickerProps } from "antd/es/date-picker";
import type { DrawerProps } from "antd/es/drawer";
import Drawer from "antd/es/drawer";
import type { DropdownProps } from "antd/es/dropdown";
import Dropdown from "antd/es/dropdown/dropdown";
import Empty from "antd/es/empty";
import Image from "antd/es/image";
import type { ImageProps } from "antd/es/image";
import Layout from "antd/es/layout";
import Menu from "antd/es/menu";
import type { MenuProps } from "antd/es/menu";
import Message from "antd/es/message";
import Modal from "antd/es/modal";
import type { ModalProps } from "antd/es/modal";
import notification from "antd/es/notification";
import type { RowProps } from "antd/es/row";
import Row from "antd/es/row";
import Radio from "antd/es/radio";
import Rate from "antd/es/rate";
import Select from "antd/es/select";
import type { SelectProps } from "antd/es/select";
import Spin from "antd/es/spin";
import Switch from "antd/es/switch";
import Progress from "antd/es/progress";
import QRCode from "antd/es/qr-code";
import Slider from "antd/es/slider";
import type { SliderSingleProps } from "antd/es/slider";
import Popover from "antd/es/popover";
import type { TableProps, TablePaginationConfig } from "antd/es/table";
import Table from "antd/es/table";
import type { TableRowSelection } from "antd/es/table/interface";
import type { ColumnType } from "antd/es/table";
import Tabs from "antd/es/tabs";
import type { TabsProps } from "antd/es/tabs";
import Timeline from "antd/es/timeline";
import type { TimelineProps } from "antd/es/timeline";
import type { TimelineItemProps } from "antd/es/timeline";
import Tooltip from "antd/es/tooltip";
import type { TooltipProps } from "antd/es/tooltip";
import type { UploadChangeParam } from "antd/es/upload";
import Upload from "antd/es/upload";
import type { UploadFile, UploadProps } from "antd/es/upload/interface";
import Space from "antd/es/space";
import Steps from "antd/es/steps";
import type { StepsProps } from "antd/es/steps";
import Timer from "antd/es/statistic/Timer";
import Carousel from "antd/es/carousel";
import ColorPicker from "antd/es/color-picker";
import Input from "antd/es/input";
import InputNumber from "antd/es/input-number";
import type { InputNumberProps } from "antd/es/input-number";

const { Content, Footer, Header } = Layout;

export {
  Row,
  RowProps,
  Radio,
  Rate,
  Drawer,
  ConfigProvider,
  DrawerProps,
  Col,
  Select,
  SelectProps,
  Table,
  TableProps,
  TablePaginationConfig,
  ColumnType,
  Modal,
  ModalProps,
  notification,
  Checkbox,
  CheckboxOptionType,
  CheckboxGroupProps,
  GetProp,
  Upload,
  Message,
  Collapse,
  CollapseProps,
  Dropdown,
  MenuProps,
  DropdownProps,
  Empty,
  Image,
  ImageProps,
  Content,
  DatePicker,
  DatePickerProps,
  Tooltip,
  TooltipProps,
  Tabs,
  TabsProps,
  TableRowSelection,
  Footer,
  Spin,
  UploadFile,
  UploadProps,
  UploadChangeParam,
  Switch,
  Progress,
  QRCode,
  Slider,
  SliderSingleProps,
  Popover,
  Avatar,
  Badge,
  Menu,
  Layout,
  Header,
  Timeline,
  TimelineProps,
  TimelineItemProps,
  Space,
  Steps,
  StepsProps,
  Timer,
  Carousel,
  ColorPicker,
  Input,
  InputNumber,
  InputNumberProps,
};
